// extracted by mini-css-extract-plugin
module.exports = {"Loader":"Spinner_Loader__2hakv","load7":"Spinner_load7__3cANQ"};